
// const desktopSearchClose = document.getElementById("desktop-search-close");
// const mobileSearchClose = document.getElementById("mobile-search-close");

// if (desktopSearchClose) {
//   desktopSearchClose.addEventListener("click", (event) => {
//     event.stopPropagation();
//     console.log(desktopSearchClose, "desktopSearchClose");
//   });
// }

// if (mobileSearchClose) {
//   mobileSearchClose.addEventListener("click", (event) => {
//     event.stopPropagation();
//     console.log(mobileSearchClose, "mobileSearchClose");
//   });
// }

var BombayShirts = function() {
    "use strict";
    ! function() {
        let n = {
            open: !1
        };
        setInterval(function() {
            window.outerHeight - window.innerHeight > 160 || window.outerWidth - window.innerWidth > 160 ? n.open || (n.open = !0) : n.open = !1
        }, 500), document.addEventListener("contextmenu", function(n) {
            (n.target.closest("[data-bombay-quickview]") || n.target.closest(".bombay-quickview-modal")) && n.preventDefault()
        }), document.addEventListener("keydown", function(n) {
            ("F12" === n.key || n.ctrlKey && n.shiftKey && "I" === n.key || n.ctrlKey && n.shiftKey && "C" === n.key || n.ctrlKey && "u" === n.key) && n.preventDefault()
        })
    }();
    const n = new class {
        constructor() {
            this.t(), this.config = {
                apiBaseUrl: "",
                customStyles: {},
                callbacks: {},
                o: !1,
                i: "1.0.0"
            }, this.init()
        }
        t() {
            if ("undefined" == typeof window || "undefined" == typeof document) throw new Error("BombayShirts library requires a browser environment")
        }
        init() {
            "loading" === document.readyState ? document.addEventListener("DOMContentLoaded", () => this.setupEventListeners()) : this.setupEventListeners(), this.config.o = !0
        }
        setupEventListeners() {
            document.addEventListener("click", n => {
                const t = n.target.closest("[data-bombay-quickview]");
                t && (n.preventDefault(), this.handleQuickviewClick(t))
            }), document.addEventListener("bombayshirts:quickview", n => {
                n.detail && this.openQuickview(n.detail)
            })
        }
        handleQuickviewClick(n) {
            const t = this.extractDataFromElement(n);
            this.openQuickview(t)
        }
        extractDataFromElement(n) {
            const t = n.dataset;
            return {
                view: "quickview",
                productHandle: t.productHandle || "",
                productType: t.productType || "",
                templateType: t.templateType || "",
                productTitle: t.productTitle || "",
                designType: t.designType || "STANDARD",
                variantId: t.variantId || null,
                customer: {
                    CustomerID: t.customerId || "",
                    state: t.customerState || "guest",
                    loginPageUrl: t.loginPageUrl || ""
                },
                added_wishlist: "true" === t.addedWishlist || !1
            }
        }
        openQuickview(n) {
            if (!n || "object" != typeof n) return;
            const t = {
                    view: "quickview",
                    productHandle: "",
                    productType: "",
                    templateType: "",
                    productTitle: "",
                    designType: "STANDARD",
                    variantId: null,
                    customer: {
                        CustomerID: "",
                        state: "guest",
                        loginPageUrl: ""
                    },
                    added_wishlist: !1
                },
                o = {
                    ...t,
                    ...n
                };
            o.customer = {
                ...t.customer,
                ...n.customer || {}
            }, ["STANDARD", "SEMI_STITCHED", "CUSTOM_DESIGN"].includes(o.designType) || (o.designType = "STANDARD"), this.executeQuickview(o)
        }
        executeQuickview(n) {
            this.triggerEvent("quickview:open", n), this.createQuickviewModal(n)
        }
        createQuickviewModal(n) {
            const t = document.getElementById("bombay-quickview-modal");
            t && t.remove();
            const o = document.createElement("div");
            o.id = "bombay-quickview-modal", o.className = "bombay-quickview-modal", o.innerHTML = this.getModalHTML(n), this.addModalStyles(), document.body.appendChild(o), this.setupModalEventListeners(o, n), setTimeout(() => o.classList.add("show"), 10)
        }
        getModalHTML(n) {
            return `\n      <div class="bombay-modal-overlay">\n        <div class="bombay-modal-content">\n          <div class="bombay-modal-header">\n            <h3>Quick View: ${n.productTitle}</h3>\n            <button class="bombay-close-btn" aria-label="Close">&times;</button>\n          </div>\n          <div class="bombay-modal-body">\n            <div class="bombay-product-info">\n              <p><strong>Product Handle:</strong> ${n.productHandle}</p>\n              <p><strong>Product Type:</strong> ${n.productType}</p>\n              <p><strong>Design Type:</strong> ${n.designType}</p>\n              <p><strong>Template:</strong> ${n.templateType}</p>\n              ${n.variantId?`<p><strong>Variant ID:</strong> ${n.variantId}</p>`:""}\n            </div>\n            <div class="bombay-customer-info">\n              <p><strong>Customer Status:</strong> ${n.customer.state}</p>\n              ${n.customer.CustomerID?`<p><strong>Customer ID:</strong> ${n.customer.CustomerID}</p>`:""}\n              <p><strong>Wishlist Status:</strong> ${n.added_wishlist?"Added":"Not Added"}</p>\n            </div>\n            <div class="bombay-modal-actions">\n              <button class="bombay-btn bombay-btn-primary" data-action="add-to-cart">Add to Cart</button>\n              <button class="bombay-btn bombay-btn-secondary" data-action="toggle-wishlist">\n                ${n.added_wishlist?"Remove from":"Add to"} Wishlist\n              </button>\n              ${"guest"===n.customer.state?'<button class="bombay-btn bombay-btn-link" data-action="login">Login</button>':""}\n            </div>\n          </div>\n        </div>\n      </div>\n    `
        }
        addModalStyles() {
            if (document.getElementById("bombay-quickview-styles")) return;
            const n = document.createElement("style");
            n.id = "bombay-quickview-styles", n.textContent = "\n      .bombay-quickview-modal {\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        z-index: 10000;\n        opacity: 0;\n        visibility: hidden;\n        transition: opacity 0.3s ease, visibility 0.3s ease;\n      }\n      \n      .bombay-quickview-modal.show {\n        opacity: 1;\n        visibility: visible;\n      }\n      \n      .bombay-modal-overlay {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background: rgba(0, 0, 0, 0.5);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        padding: 20px;\n      }\n      \n      .bombay-modal-content {\n        background: white;\n        border-radius: 8px;\n        max-width: 600px;\n        width: 100%;\n        max-height: 90vh;\n        overflow-y: auto;\n        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n      }\n      \n      .bombay-modal-header {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 20px 20px 0 20px;\n        border-bottom: 1px solid #eee;\n        margin-bottom: 20px;\n      }\n      \n      .bombay-modal-header h3 {\n        margin: 0;\n        color: #333;\n        font-size: 1.25em;\n      }\n      \n      .bombay-close-btn {\n        background: none;\n        border: none;\n        font-size: 24px;\n        cursor: pointer;\n        padding: 0;\n        width: 30px;\n        height: 30px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        color: #999;\n      }\n      \n      .bombay-close-btn:hover {\n        color: #333;\n      }\n      \n      .bombay-modal-body {\n        padding: 0 20px 20px 20px;\n      }\n      \n      .bombay-product-info,\n      .bombay-customer-info {\n        margin-bottom: 20px;\n      }\n      \n      .bombay-product-info p,\n      .bombay-customer-info p {\n        margin: 8px 0;\n        color: #666;\n      }\n      \n      .bombay-modal-actions {\n        display: flex;\n        gap: 10px;\n        flex-wrap: wrap;\n      }\n      \n      .bombay-btn {\n        padding: 10px 20px;\n        border: none;\n        border-radius: 4px;\n        cursor: pointer;\n        font-size: 14px;\n        transition: background-color 0.2s ease;\n      }\n      \n      .bombay-btn-primary {\n        background: #007bff;\n        color: white;\n      }\n      \n      .bombay-btn-primary:hover {\n        background: #0056b3;\n      }\n      \n      .bombay-btn-secondary {\n        background: #6c757d;\n        color: white;\n      }\n      \n      .bombay-btn-secondary:hover {\n        background: #545b62;\n      }\n      \n      .bombay-btn-link {\n        background: transparent;\n        color: #007bff;\n        text-decoration: underline;\n      }\n      \n      .bombay-btn-link:hover {\n        color: #0056b3;\n      }\n    ", document.head.appendChild(n)
        }
        setupModalEventListeners(n, t) {
            const o = n.querySelector(".bombay-close-btn");
            o?.addEventListener("click", () => this.closeModal(n));
            const e = n.querySelector(".bombay-modal-overlay");
            e?.addEventListener("click", t => {
                t.target === e && this.closeModal(n)
            }), n.addEventListener("click", o => {
                const e = o.target.closest("[data-action]");
                e && this.handleModalAction(e.dataset.action, t, n)
            });
            const i = t => {
                "Escape" === t.key && (this.closeModal(n), document.removeEventListener("keydown", i))
            };
            document.addEventListener("keydown", i)
        }
        handleModalAction(n, t, o) {
            switch (n) {
                case "add-to-cart":
                    this.triggerEvent("quickview:add-to-cart", t);
                    break;
                case "toggle-wishlist":
                    t.added_wishlist = !t.added_wishlist, this.triggerEvent("quickview:toggle-wishlist", {
                        ...t,
                        action: t.added_wishlist ? "add" : "remove"
                    });
                    const n = o.querySelector('[data-action="toggle-wishlist"]');
                    n && (n.textContent = t.added_wishlist ? "Remove from Wishlist" : "Add to Wishlist");
                    break;
                case "login":
                    t.customer.loginPageUrl ? window.location.href = t.customer.loginPageUrl : this.triggerEvent("quickview:login-required", t)
            }
        }
        closeModal(n) {
            n.classList.remove("show"), setTimeout(() => {
                n.parentNode && n.parentNode.removeChild(n)
            }, 300), this.triggerEvent("quickview:close")
        }
        triggerEvent(n, t = null) {
            const o = new CustomEvent(`bombayshirts:${n}`, {
                detail: t,
                bubbles: !0,
                cancelable: !0
            });
            document.dispatchEvent(o)
        }
        addEventListener(n, t) {
            document.addEventListener(`bombayshirts:${n}`, t)
        }
        removeEventListener(n, t) {
            document.removeEventListener(`bombayshirts:${n}`, t)
        }
        configure(n) {
            this.config = {
                ...this.config,
                ...n
            }
        }
    };
    if (Object.defineProperty(n, "l", {
            value: !0,
            writable: !1,
            enumerable: !1,
            configurable: !1
        }), "function" == typeof Object.freeze && Object.freeze(n.constructor.prototype), "undefined" != typeof module && module.exports && (module.exports = n), "undefined" != typeof window) {
        window.BombayShirts = n;
        try {
            Object.defineProperty(window, "BombayShirts", {
                writable: !1,
                configurable: !1
            })
        } catch (t) {}
    }
    return setTimeout(() => !("object" != typeof n || !n.config), 1e3), n
}();